<template>
  <div class="company-detail">
    <div class="sub-content">
      <div class="bg">
        <img :src="bg_img" alt />
      </div>
      <div class="content">
        <wy-card padding="0.2rem 0.15rem" margin="0 0 0.15rem 0">
          <div>
            <div>
              <img style="max-width: 0.68rem;" :src="companyInfo.logo_url" alt />
            </div>
            <div class="company-title">
              <span class="title-sm">
                {{companyInfo.company_name}}
                <span
                  class="iconfont icon-xinyong credit-tip"
                  v-if="credit_info"
                >
                  <span>{{credit_info.income_audit_grade + credit_info.info_integrity_grade + credit_info.recruit_liveness_grade}}</span>
                </span>
              </span>
            </div>
            <van-row class="company-desc" gutter="5">
              <van-col span="3">{{companyInfo.city_name}}</van-col>
              <van-col span="5">{{companyInfo.company_property}}</van-col>
              <van-col span="8">规模{{companyInfo.scale}}</van-col>
              <van-col span="8">{{companyInfo.industry_category}}</van-col>
            </van-row>

            <div class="company-btn">
              <van-button type="info" v-if="!stateInfo.hasResister">去报名</van-button>
              <div v-else>
                <div v-if="stateInfo.invitationApply">
                  <div class="apply-box" v-if="stateInfo.invitationApply.job_name">
                    <div class="apply-desc">面试职位: {{stateInfo.invitationApply.job_name}}</div>
                    <div
                      class="apply-desc"
                      v-if="stateInfo.invitationApply.interview_time"
                    >面试时间: {{stateInfo.invitationApply.interview_time}}</div>
                  </div>

                  <div style="text-align: center;">
                    <span v-if="stateInfo.invitationApply.interview_state">
                      <van-button
                        type="info"
                        v-if="parseInt(stateInfo.invitationApply.interview_state) < 2"
                        @click="dealFn"
                      >{{faceState[parseInt(stateInfo.invitationApply.interview_state)]}}</van-button>
                      <van-button
                        type="default"
                        v-else
                      >{{faceState[parseInt(stateInfo.invitationApply.interview_state)]}}</van-button>
                    </span>
                    <span v-else>
                      <van-button
                        type="info"
                        v-if="parseInt(stateInfo.invitationApply.state) < 2"
                        @click="dealFn"
                      >{{queueState[stateInfo.invitationApply.state + '-' + stateInfo.invitationApply.type]}}</van-button>
                      <van-button
                        type="default"
                        v-else
                      >{{queueType[parseInt(stateInfo.invitationApply.type)] + ":" + queueState[stateInfo.invitationApply.state + '-' + stateInfo.invitationApply.type]}}</van-button>

                      <span
                        style="margin-left: 0.1rem;"
                        v-if="companyOnline[stateInfo.invitationApply.video_erp_register_id] && parseInt(stateInfo.invitationApply.state) === 1"
                      >
                        <van-button
                          type="danger"
                          v-if="companyBusiness[stateInfo.invitationApply.video_erp_register_id]"
                          @click="promptBusiness"
                        >
                          <span class="iconfont icon-Icon-shipin"></span>忙碌
                        </van-button>
                        <van-button
                          type="info"
                          v-else
                          @click="launchInterviewFn(stateInfo.invitationApply.video_erp_register_id, stateInfo.invitationApply.invitation_apply_id)"
                        >
                          <span class="iconfont icon-Icon-shipin"></span>发起视频
                        </van-button>
                      </span>
                    </span>
                  </div>
                </div>
                <van-button v-else type="info" @click="showJobFn">申请面试</van-button>
              </div>
            </div>
          </div>
        </wy-card>

        <wy-card class="new-tabs" padding="0">
          <tabs v-model="tabsIndex" swipeable @change="tabsFn">
            <tab v-for="(item, index) in tabList" :key="index" :name="index" :title="item.name">
              <wy-card>
                <company-basic
                  v-if="item.key === 'companyInfo'"
                  :company-info="companyInfo"
                  :brand-info="brandInfo"
                ></company-basic>
                <jobs v-if="item.key === 'jobs'" :list="jobs" :company-info="companyInfo"></jobs>
                <interview v-if="item.key === 'interview'" :list="interview"></interview>
              </wy-card>
            </tab>
          </tabs>
        </wy-card>
      </div>
    </div>

    <action-sheet
      v-model="showJob"
      :actions="actionsJob"
      @select="onSelectJob"
      title="选择职位"
      cancel-text="取消"
    />

    <action-sheet
      v-model="showAction"
      :actions="actionsList"
      @select="onSelectFn"
      cancel-text="取消"
    />
  </div>
</template>

<script>
import WyCard from "@/components/WyCard";
import { mapState } from "vuex";

import { Tabs, Tab, ActionSheet } from "vant";
import CompanyBasic from "./CompanyBasic";
import Jobs from "./Jobs";
import Interview from "./Interview";

export default {
  name: "company-detail",
  components: { WyCard, Tabs, Tab, CompanyBasic, Jobs, Interview, ActionSheet },
  props: {
    detailData: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      route: state => state.route,
      sign: state => state.sign,
      myApplyObj: state => state.myApplyObj,
      faceState: state => state.faceState,
      queueState: state => state.queueState,
      queueType: state => state.queueType,
      user_name: state => state.user_name,
      companyOnline: state => state.companyOnline,
      companyBusiness: state => state.companyBusiness
    })
  },
  data() {
    return {
      bg_img: "/img/bg.png",
      jobfair_img: "/img/company_logo.png",
      companyInfo: {},
      jobs: [],
      interview: [],
      credit_info: {},
      brandInfo: {},
      stateInfo: {},
      video_jobfair_id: "",
      video_erp_register_id: "",
      company_id: "",
      tabsIndex: 1,
      tabList: [
        { name: "单位信息", key: "companyInfo" },
        { name: "在招职位", key: "jobs" },
        { name: "面试官信息", key: "interview" }
      ],

      showJob: false,
      actionsJob: [],
      is_props: false,

      showAction: false,
      actionsList: [
        { name: "接受邀约", state: 1 },
        { name: "拒绝邀约", state: 2 }
      ]
    };
  },
  created() {
    let { company_id, video_erp_register_id, video_jobfair_id } =
      this.detailData || {};
    if (company_id && video_erp_register_id && video_jobfair_id) {
      this.is_props = true;
    } else {
      video_erp_register_id = this.$util.getQueryString(
        "video_erp_register_id"
      );
      company_id = this.$util.getQueryString("company_id");
      video_jobfair_id = this.$util.getQueryString("video_jobfair_id");
    }

    if (company_id && video_erp_register_id && video_jobfair_id) {
      this.video_erp_register_id = video_erp_register_id;
      this.company_id = company_id;
      this.video_jobfair_id = video_jobfair_id;
      this.getDetail();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getDetail() {
      let that = this;
      const {
        video_erp_register_id,
        company_id,
        video_jobfair_id,
        sign
      } = that;
      if (!(company_id && video_erp_register_id && video_jobfair_id)) {
        that.$dialog
          .alert({
            title: "参数错误",
            message: "点击确定将回到视频双选会列表界面"
          })
          .then(() => {
            that.$router.push({ path: "/" });
          });
        return;
      }

      return new Promise(resolve => {
        that.$util
          .get("kzp_video_jobfair", "video_company_detail", {
            video_erp_register_id,
            company_id,
            video_jobfair_id,
            sign
          })
          .then(res => {
            const { code, msg, data } = res;

            if (code === 1) {
              const {
                company,
                jobs,
                interview,
                credit_info,
                brand,
                state_info
              } = data || {};
              that.$set(that, "companyInfo", company);
              that.$set(that, "jobs", jobs);
              that.$set(that, "interview", interview);
              that.$set(that, "credit_info", credit_info);
              that.$set(that, "brandInfo", brand);
              that.$set(that, "stateInfo", state_info);

              if (that.is_props === false) {
                this.$store.commit("setSubTitle", {
                  title: company.company_name || ""
                });
              }
            } else {
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger"
              });
            }

            resolve();
          });
      });
    },
    tabsFn(name) {
      this.tabsIndex = name;
    },
    dealFn() {
      let that = this;

      const {
        video_erp_register_id,
        video_jobfair_id,
        // queueType,
        stateInfo
      } = that;

      const {
        type,
        invitation_apply_id,
        state,
        interview_state
      } = stateInfo.invitationApply;

      const int_interview_state = parseInt(interview_state);
      const int_type = parseInt(type);
      const int_state = parseInt(state);

      if (int_interview_state >= 1) {
        // 面试中、已面试  不处理
        return;
      }

      if (
        (int_type === 1 && int_state < 2) ||
        (int_type === 0 && int_state > 0)
      ) {
        // 申请面试 video_erp_register_id
        this.$util
          .makesueTwice({
            title: "取消排队?",
            message: "确认取消面试排队?"
          })
          .then(res => {
            if (res) {
              that.cancelQueue(invitation_apply_id).then(res => {
                const { code } = res;
                if (code === 1) {
                  that.$notify({
                    message: "取消排队成功!",
                    type: "success"
                  });

                  if (parseInt(state) === 1) {
                    that.$store.commit("update_single_state", {
                      key: "websocket_send_data",
                      data: {
                        flag: "notice",
                        msg_from: "user",
                        receiver_uid: video_erp_register_id,
                        business_type: "取消",
                        business_txt: (that.user_name || "") + "取消了面试排队",
                        business_id: invitation_apply_id,
                        group_id: video_jobfair_id
                      }
                    });
                  }
                }
              });
            }
          });
        return;
      }

      //
      if (int_type === 0 && int_state <= 0) {
        this.currentItem = stateInfo.invitationApply;
        this.showAction = true;
      }

      // const queueName = queueType[parseInt(type)];

      // this.$util
      //   .makesueTwice({
      //     title: queueName,
      //     message: "点击确定即进入我的面试处理" + queueName
      //   })
      //   .then(res => {
      //     if (res) {
      //       that.$store.commit("update_change_jobfair", {
      //         video_jobfair_id
      //       });

      //       const current_type = parseInt(type) === 2 ? "face" : "wait";
      //       sessionStorage.setItem("current_type", current_type);

      //       that.$router.push({ path: "/sub/my_jobfair" });
      //     }
      //   });
    },
    cancelQueue(invitation_apply_id) {
      if (!invitation_apply_id) {
        this.$notify({
          message: "无效的id,请稍后再试!",
          type: ""
        });

        return;
      }

      const { sign, video_jobfair_id } = this;

      let that = this;

      const params = {
        invitation_apply_id,
        video_jobfair_id,
        is_delete: 1,
        sign
      };

      that.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });

      return new Promise(resolve => {
        that.$util.post("kzp_video_jobfair", "apply", params).then(res => {
          const { msg, code } = res;

          that.$toast.clear();

          if (code === 1) {
            that.getDetail();
            that.onRefresh();
          } else {
            // 提示错误
            that.$notify({
              message: msg || "取消排队失败,请稍后再试!",
              type: "danger"
            });
          }
          resolve(res);
        });
      });
    },
    showJobFn() {
      let actionsJob = [];
      const { jobs } = this;
      if (jobs) {
        jobs.forEach(job => {
          actionsJob.push({
            name: job.job_name,
            subname: job.salary,
            publish_id: job.publish_id
          });
        });
      }

      if (actionsJob.length <= 0) {
        this.$notify({
          message: "当前公司没有在招职位,无法申请!",
          type: "warning"
        });
        return;
      }

      this.actionsJob = actionsJob;

      this.showJob = true;
    },
    onSelectJob(item) {
      const { publish_id, name } = item;

      let that = this;

      const { video_erp_register_id, video_jobfair_id } = that;

      that.showJob = false;

      this.$util
        .makesueTwice({
          title: "面试排队?",
          message: "确认申请" + name + "职位的面试排队?"
        })
        .then(res => {
          if (res) {
            that.submitQueue(publish_id, name).then(res => {
              const { code, data } = res;
              if (code === 1) {
                that.$store.commit("update_single_state", {
                  key: "websocket_send_data",
                  data: {
                    flag: "notice",
                    msg_from: "user",
                    receiver_uid: video_erp_register_id,
                    business_type: "申请",
                    business_txt:
                      (that.user_name || "") + "申请了你发布的职位" + name,
                    business_id: data,
                    group_id: video_jobfair_id
                  }
                });

                // 提示排队成功
                that.$notify({
                  message: "申请面试排队成功，待企业确认!",
                  type: "success"
                });
              }
            });
          }
        });
    },
    submitQueue(publish_id, job_name) {
      const {
        sign,
        company_id,
        video_erp_register_id,
        video_jobfair_id
      } = this;
      const { company_name } = this.companyInfo;

      let that = this;

      const params = {
        publish_id,
        job_name,
        company_name,
        video_erp_register_id,
        company_id,
        video_jobfair_id,
        sign
      };

      that.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });

      return new Promise(resolve => {
        that.$util.post("kzp_video_jobfair", "apply", params).then(res => {
          const { msg, code } = res;

          that.$toast.clear();

          if (code === 1) {
            that.getDetail();
            that.onRefresh();
          } else {
            // 提示错误
            that.$notify({
              message: msg || "排队失败,请稍后再试!",
              type: "danger"
            });
            that.$util.goToWxResume(msg);
          }
          resolve(res);
        });
      });
    },
    beginInterview(invitation_apply_id, video_erp_register_id) {
      let that = this;
      that.$util
        .makesueTwice({
          title: "向企业发起视频",
          message:
            "确定向企业发起视频? 点击确定后会向企业发起视频请求，如果超过45s企业未应答会自动断开。"
        })
        .then(res => {
          if (res) {
            const { user_name } = that;
            // 发起视频请求
            that.$store.commit("update_single_state", {
              key: "websocket_send_data",
              data: {
                flag: "notice",
                receiver_uid: video_erp_register_id,
                business_txt: user_name + "向你发起了面试申请",
                business_type: "面试",
                business_id: invitation_apply_id
              }
            });

            // 等待企业的反馈
            that.$store.commit(
              "update_wait_invitation_apply_id",
              invitation_apply_id
            );
          }
        });
    },
    getApplyDetail(invitation_apply_id) {
      let that = this;
      return new Promise(resolve => {
        const { sign } = that;
        const params = {
          invitation_apply_id,
          sign
        };

        that.$util
          .get("kzp_video_jobfair", "video_invitation_detail", params)
          .then(res => {
            const { code, msg } = res;
            if (code !== 1) {
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger",
                onClose: () => {}
              });
            }

            resolve(res);
          });
      });
    },
    promptBusiness() {
      this.$dialog.alert({
        title: "忙碌中",
        message: "企业正在忙碌中，请稍后再试!"
      });
    },
    launchInterviewFn(video_erp_register_id, invitation_apply_id) {
      let that = this;
      const { companyBusiness, companyOnline } = that;
      if (companyBusiness[video_erp_register_id]) {
        that.promptBusiness();
        return;
      }

      if (companyOnline[video_erp_register_id]) {
        // 查询当前的状态
        that.getApplyDetail(invitation_apply_id).then(({ code, data }) => {
          if (code !== 1) {
            that.onRefresh();
            return;
          }

          const { interview_state, state } = data || {};
          if (parseInt(state) !== 1 || parseInt(interview_state) === 2) {
            that.$dialog.alert({
              title: "暂时不能发起视频",
              message: "当前排队状态已改变，已为您更新为最新数据!"
            });
            that.onRefresh();
            return;
          }

          // 向企业发起视频
          that.beginInterview(invitation_apply_id, video_erp_register_id);
        });
      } else {
        // 提示hr不在线，只有当hr在线时才能发起视频
        that.$dialog.alert({
          title: "当前企业不在线",
          message: "只有企业在线时才能发起视频!"
        });
      }
    },
    onRefresh() {
      let that = this;
      if (that.detailData && that.detailData.company_id) {
        that.$emit("refresh", {});
      }
    },
    onSelectFn(item) {
      const { state } = item;
      this.dealInvitation(state);
      this.showAction = false;
    },
    dealInvitation(state) {
      const { sign, currentItem, user_name } = this;

      const {
        invitation_apply_id,
        video_erp_register_id,
        video_jobfair_id
      } = currentItem;

      let that = this;

      const params = {
        invitation_apply_id,
        state,
        sign
      };

      that.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });

      return new Promise(resolve => {
        that.$util.post("kzp_video_jobfair", "accept", params).then(res => {
          const { msg, code } = res;

          that.$toast.clear();

          if (code === 1) {
            // 通知pc  处理结果
            that.$store.commit("update_single_state", {
              key: "websocket_send_data",
              data: {
                flag: "notice",
                receiver_uid: video_erp_register_id,
                business_txt:
                  user_name + (state === 1 ? "同意" : "拒绝") + "了你的邀约",
                business_type: "处理邀约",
                business_id: invitation_apply_id,
                group_id: video_jobfair_id
              }
            });

            // 刷新
            that.getDetail();
            that.onRefresh();
          } else {
            // 提示错误
            that.$notify({
              message: msg || "操作失败,请稍后再试!",
              type: "danger"
            });
          }
          resolve(res);
        });
      });
    }
  }
};
</script>

<style lang="scss">
.company-desc-text {
  img {
    max-width: 100%;
  }
}

$tabBgGray: rgba(226, 226, 226, 0.26);
$tabFont: #3a3a3a;
$activeFont: #358ede;

$white: #fff;

.new-tabs {
  [class*="van-hairline"]::after {
    border: none;
  }

  .van-hairline--top-bottom,
  .van-tabs__nav--line {
    background-color: $tabBgGray;
    margin-bottom: 0;
    height: 0.4rem;
  }

  .van-tabs__line {
    display: none;
  }

  .van-tab {
    color: $tabFont;
    font-size: 0.14rem;
    line-height: 0.4rem;
  }

  .van-tab--active {
    color: $activeFont;
    background-color: $white;
  }
}
</style>

<style lang="scss" scoped>
.company-detail {
  .sub-content {
    position: relative;
    height: 100%;
    width: 100%;

    .credit-tip {
      color: #f6404d;
      font-size: 0.14rem;
      line-height: 0.14rem;
      font-weight: normal;
      display: inline-block;
      @include transform(scale(0.8, 0.8));

      span {
        font-size: 0.12rem;
      }
    }

    > .bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    > .content {
      position: relative;
      z-index: 10;
      padding: 0.55rem 0.15rem 0.15rem;
      @include box-sizing(border-box);

      .company-title {
        font-size: 0.16rem;
        font-weight: bold;
        line-height: 0.2rem;
        text-align: center;
        margin-top: 0.15rem;
      }

      .company-desc {
        font-size: 0.12rem;
        line-height: 0.16rem;
        color: #999;
        margin-bottom: 0.2rem;

        .van-col {
          text-align: center;
          @include over-ellipsis();
        }
      }

      .company-btn {
        margin-top: 0.15rem;

        .apply-box {
          padding: 0.15rem 0;
          .apply-desc {
            line-height: 0.2rem;
            font-size: 0.14rem;
            text-align: center;
            color: #999;
          }
        }
      }

      .company-desc {
        text-align: left;
        .company-desc-text {
          // text-indent: 2em;
        }
      }
    }
  }
}
</style>

